import { ITermSchema } from '../internalTypes';
import { getServiceId } from './getServiceId';

export function getSelectedServiceId(terms: ITermSchema[]): string | null {
  const paidService = terms.find(term => {
    const { publishOptions } = term;

    const periods = publishOptions?.periods || [];
    const packages = publishOptions?.servicePackages || [];

    const hasPaidPeriod = !!periods.find(({ isPaid }) => isPaid);
    const hasPaidPackage = !!packages.find(({ isPaid }) => isPaid);

    return hasPaidPeriod || hasPaidPackage;
  });

  const defaultService = terms.find(({ isDefault }) => isDefault);

  if (paidService) {
    return getServiceId(paidService);
  }

  if (defaultService) {
    return getServiceId(defaultService);
  }

  return null;
}
